import React from "react";
import { createPortal } from "react-dom";

/**
 * components/composer/ComposerDropOverlay.tsx —— 全视口拖放提示层（U-1d）
 * 落点：102 `components/ComposerDropOverlay.vue`(47 行) 逐条译 React+TS（F2 批）。
 * 依据：升级方案 §2 批 U-1d 行「全视口拖放提示层：文件拖到窗口任意位置出现提示层」；
 *   102 注释所引旧面等价物＝`ChatView.vue:103-106,196-201`（遮罩挂会话主区）＋ `useChatEngine.js:1514-1530`
 *   （dragCounter 计数防子元素 enter/leave 抖动——语义迁移进 `composables/useComposerDropTarget.ts`）。
 * 🔴 102 宿主配合问题的本树落法同款：本件**不挂宿主事件**，window 级监听由
 *   `useComposerDropTarget` 自持；提示层以 fixed 定位覆盖全视口、**Teleport 到 body**（102 `Teleport to="body"`）。
 * a11y（P0：状态文本等价）：`role="status"`＋可见文案；纯提示层**不拦截落点判定**——drop 事件
 *   统一在 window 层裁决（`preventDefault` 后取 `dataTransfer.files`），浮层自身 `pointer-events:none`
 *   （避免浮层闪现导致 dragleave 计数抖动，同 ShellOverlay「不拦截指针」纪律 §2.4）。
 * 组件三戒：不发请求（文件经 onFiles 回调上抛给 Composer 附件栏）。
 */

export interface ComposerDropOverlayProps {
  /** 是否显示（`useComposerDropTarget.dragging`） */
  visible: boolean;
}

export function ComposerDropOverlay(props: ComposerDropOverlayProps): React.ReactElement | null {
  if (!props.visible) return null;
  return createPortal(
    <div className="xg-drop-overlay" data-testid="composer-drop-overlay" role="status">
      <div className="xg-drop-overlay__inner">
        <span className="xg-drop-overlay__icon" aria-hidden="true">⬇</span>
        <span className="xg-drop-overlay__text">释放以上传文件 / 图片</span>
        <span className="xg-drop-overlay__hint">文件将加入当前会话的草稿附件</span>
      </div>
    </div>,
    document.body,
  );
}

export default ComposerDropOverlay;
